import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import Store from '../../Store';
import { OnModuleCreatorOpen, OnModuleCreatorOpenToggle } from '../../ModuleCreator/_actions/ModuleCreatorActions';
import ModuleAdd, { Props } from '../_components/ModuleAdd';

const mapStateToProps = (store:Store, props:Props) => ({
	selectedCategory: store.getIn(['create', 'moduleCreator', 'category']),
	moduleCreatorOpened: store.getIn(['create', 'moduleCreator', 'opened']),
});

const mapDispatchToProps = (dispatch: Dispatch, props: Props) => ({
	onClick: () => dispatch(OnModuleCreatorOpen(props.category)),
	onModuleCreatorOpenToggle: () => dispatch(OnModuleCreatorOpenToggle(props.category))
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ModuleAdd);